import type { MemberSummary } from '../../hooks/home/useHomeData'
import Avatar, { getInitials } from '../primitives/Avatar'
import Card from '../primitives/Card'
import styles from './MemberCard.module.css'

interface MemberCardProps {
  member: MemberSummary
  onClick?: () => void
}

const ROLE_LABELS = {
  you: 'You',
  leader: 'Leader',
  teammate: 'Teammate',
} as const

export default function MemberCard({ member, onClick }: MemberCardProps) {
  const { user, role, totalRms, teamPercent, buckets } = member

  return (
    <Card className={styles.card} onClick={onClick} data-testid="member-card">
      <div className={styles.top}>
        <Avatar
          initials={getInitials(user.firstName, user.lastName)}
          photoUrl={user.photoUrl}
          variant={role === 'you' ? 'you' : role === 'leader' ? 'leader' : 'default'}
        />
        <div className={styles.info}>
          <div className={styles.name}>
            {user.firstName} {user.lastName?.charAt(0)}.
          </div>
          <div className={styles.role}>{ROLE_LABELS[role]}</div>
        </div>
        <div className={styles.rm}>
          <span>
            <span className={styles.rmVal}>{totalRms}</span>
            <span className={styles.rmUnit}>RMs</span>
          </span>
          <span className={styles.rmPct}>{teamPercent}% of team</span>
        </div>
      </div>
      <div className={styles.split}>
        {buckets.map((b) => (
          <div key={b.label} className={styles.seg}>
            <div className={styles.segLabel}>{b.label}</div>
            <div className={styles.segVal}>{b.value}</div>
            <div className={styles.segPct}>{b.teamPercent}% of team</div>
          </div>
        ))}
      </div>
    </Card>
  )
}
